import React, { Component } from 'react';
import * as $ from 'jquery';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../../GlobalContext';
import { Link } from 'react-router-dom';
import * as MySound from '../../MySound';
import { confirm } from 'react-bootstrap-confirmation';
import { alert } from 'react-bootstrap-confirmation';
import ViewAttributes from '../ViewAttributes';


export class AdhocCount_ConfirmQty extends Component {
    static displayName = AdhocCount_ConfirmQty.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            alertMessage: "",
            selectedStocktake:"",
            selectedStockLine: props.location.state.selectedStockLine,
            selectedLocationId: props.location.state.selectedLocationId,
            previouspage: props.location.state.previouspage,
            enteredQty: 0,
            productBarCode: "",
            displayViewAttributes: false,
            attributesViewedByStaff: false,
            productHasAttributes: false,
            scanCountQty: 0,
            isScanStocktake: false,
            scanCheckInputValue: "",
            scanCountCheckBoxChecked: false,
            displayAttributesAsConfirmModal: true,
            startTime: "",
            countTimeInSeconds: 0,
            timerStarted: false,
            locationBarcode: "",
            travelTimeInSeconds: 0,

        };
        this.history = props.history;
    }

    componentDidMount() {

        if (MyGlobal.isStockCounted === "true") {
            this.navigateToPreviousPage();
            return;
        }

        if (!MyGlobal.selected_stocktake) {
            this.clearAll("Please select a Stocktake");
            return;
        }

        var selectedStocktakeParsedData = JSON.parse(MyGlobal.selected_stocktake);
        if (selectedStocktakeParsedData) {
            this.state.selectedStocktake = selectedStocktakeParsedData;
        }

        if (!this.state.selectedStocktake.stocktakeId || this.state.selectedStocktake.stocktakeId === "") {
            this.clearAll("Please select a Stocktake");
            return;
        }


        this.setState({ startTime: new Date(), timerStarted: true });
        this.refs.scanCheckInput.focus();
        this.state.productHasAttributes = this.state.selectedStockLine.productAttribute !== 0 ? true : false;
        this.state.isScanStocktake = this.state.selectedStocktake.isScanStocktake === "true" ? true : false;
        this.state.scanCountCheckBoxChecked = this.state.isScanStocktake;
        this.getProductBarcode();
        if (this.state.selectedStockLine.productLineInLocationCount > 1) {


            const displayMultipleProductLinesAlert = async () => {
                alert("Location contains multiple (" + this.state.selectedStockLine.productLineInLocationCount + ") product lines, please count " + this.state.selectedStockLine.productCode);

            }
            displayMultipleProductLinesAlert();
        }

        this.state.locationBarcode = this.state.selectedStockLine.locationRow.trim() + "-" + this.state.selectedStockLine.locationColumn + "-" + this.state.selectedStockLine.locationLevel + "-" + this.state.selectedStockLine.locationTray;

    }
    goto(page) {
        this.history.push({
            pathname: page,
            state: this.state
        });
    }

    confirmQty() {

        if (this.state.enteredQty === this.state.productBarCode) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Invalid quantity, quantity value is identical to barcode" });
            return;
        }

        if ($.isNumeric(this.state.enteredQty) === false) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Invalid quantity" });
            return;
        }

        if (this.state.scanCountCheckBoxChecked === true && this.state.enteredQty === 0) {
            this.state.enteredQty = this.state.scanCountQty;
        }

        if (this.state.enteredQty && this.state.enteredQty.length > 4) {
            const displayValidateQtyConfirmation = async () => {
                const confirmationResult = await confirm("Please confirm quantity entered is correct");
                if (confirmationResult === true) {
                    this.confirmQtyToWS();
                }
                else {
                    this.setState({ enteredQty: 0 });
                    return;
                }
            }
            displayValidateQtyConfirmation();
        }
        else
        {
            this.confirmQtyToWS();
        }

    }

    displayAttributes(isConfirm) {

        this.setState({ displayAttributesAsConfirmModal: isConfirm, attributesViewedByStaff: true, displayViewAttributes: true });
    }

    async confirmQtyToWS() {
        this.state.loading = true;

        if (this.state.productHasAttributes === true && this.state.attributesViewedByStaff === false) {
            this.state.loading = false;
            this.displayAttributes(true);
            return;
        }

        //Calculate the ime it took to Count 
        if (this.state.timerStarted === true) {
            var currentTime = new Date();
            var countTime = (currentTime - this.state.startTime) / 1000;
            this.state.countTimeInSeconds = countTime;
        }

        const confirmStockQtyRequestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                StocktakeId: this.state.selectedStocktake.stocktakeId,
                StocktakeLineId: this.state.selectedStockLine.stocktakeLineID,
                CountTime: this.state.countTimeInSeconds,
                TravelTime: this.state.travelTimeInSeconds,
                LatestCount: this.state.enteredQty,
                CountedByStaffId: MyGlobal.user

            })
        };
        fetch('api/Stocktake/SubmitAdhocLineCount', confirmStockQtyRequestOptions)
            .then(async response => {
                this.state.loading = false;

                // check for error response
                if (!response.ok) {
                    MySound.play(MySound.Sound.stop);
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Failed to update Quantity!! " + errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            if (data.isError === false) {
                                MyGlobal.isStockCounted = "true";
                                this.setState({ alertMessage: data.responseDescription });
                                MySound.play(MySound.Sound.next);

                                this.navigateToPreviousPage();
                               
                            }
                            else {
                                MySound.play(MySound.Sound.stop);
                                this.setState({ alertMessage: "Failed to update Quantity!!  " + data.responseDescription });
                            }
                        }
                        else {
                            MySound.play(MySound.Sound.stop);
                            this.setState({ alertMessage: "Failed to update Quantity!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        MySound.play(MySound.Sound.stop);
                        this.setState({ alertMessage: "Failed to update Quantity!!" });
                    }

                }
            })
            .catch(error => {
                MySound.play(MySound.Sound.stop);
                this.state.loading = false;
                this.setState({ alertMessage: error });
            });

    }

    navigateToPreviousPage() {
        switch (this.state.previouspage) {
            case "Recount_ConfirmLocation":
                this.goto("../Recount/Recount_ConfirmLocation");
                break;
            case "FirstCount_ConfirmLocation":
                this.goto("../FirstCount/FirstCount_ConfirmLocation");
                break;
            default:
                this.goto("../StocktakeTasks");
        }
    }

    async getProductBarcode() {
        this.state.loading = true;

        fetch(`api/Stocktake/GetProductBarcode?productId=${this.state.selectedStockLine.productID}`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;


                    if (apiResponse) {
                        const data = apiResponse.data[0];
                        if (apiResponse.success) {
                            this.setState({ productBarCode: data.column1, alertMessage: "" });
                        }
                        else {
                            this.setState({ productBarCode: "", alertMessage: "Failed to load product barcode!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ productBarCode: "", alertMessage: "Failed to load product barcode!!" });
                    }
                }

            })
            .catch(error => {
                this.setState({ productBarCode: "", alertMessage: error });
            });
    }

    async getProductIdByBarcode() {
        this.state.loading = true;
        if (!this.state.scanCheckInputValue || this.state.scanCheckInputValue === "") {
            this.state.loading = false;
            return;
        }

        fetch(`api/Stocktake/GetProductIdByBarcode?stocktakeId=${this.state.selectedStocktake.stocktakeId}&barcode=${this.state.scanCheckInputValue.trim()}`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Failed to load product!!  " + errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;


                    if (apiResponse) {
                        const matchingProducts = apiResponse.data;
                        if (apiResponse.success) {
                            if (matchingProducts.length === 0) {
                                this.setState({ alertMessage: "No product found" });
                                MySound.play(MySound.Sound.stop);
                                return;
                            }
                            if (matchingProducts.length > 1) {
                                this.setState({ alertMessage: "Error - Multiple products contain the same barcode." });
                                MySound.play(MySound.Sound.stop);
                                return;
                            }
                            if (matchingProducts.length === 1) {

                                var matchingProduct = matchingProducts[0];
                                if (matchingProduct.product_ID !== this.state.selectedStockLine.productID) {
                                    this.setState({ alertMessage: "Product code not a match" });
                                    MySound.play(MySound.Sound.stop);
                                    return;
                                }

                                if (this.state.scanCountCheckBoxChecked) {
                                    //increase scanned qty by pack size
                                    this.state.scanCountQty += matchingProduct.packSize;
                                    this.setState({ scanCheckInputValue: "" });
                                    MySound.play(MySound.Sound.next);
                                }
                                else {
                                    this.setState({ alertMessage: "Product validated! " + matchingProduct.code, scanCheckInputValue: "" });

                                    //TODO: Check why text isnt clearing
                                    MySound.play(MySound.Sound.next);
                                }
                            }
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load product!!  " + apiResponse.errorMessage });
                            return;
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load product!!" });
                        return;
                    }
                }

            })
            .catch(error => {
                this.setState({ alertMessage: "Failed to load product!!  " + error });
            });


    }



    render() {


        const handleQtyInputKeyPress = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.confirmQty();
            }
        };

        const handleScancheckKeyPress = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.getProductIdByBarcode();
            }
        };

        const handleScanCountChkChanged = e => {
            if (e.target.checked) {
                this.refs.scanCheckInput.focus();
            }

            this.setState({ scanCountQty: 0, scanCountCheckBoxChecked: e.target.checked });

        };

        const handleConfirmBtnClick = e => {

            if (this.state.isScanStocktake === true) {

                if (this.state.scanCountQty === 0) {

                    const displayConfirmation = async () => {
                        const confirmationResult = await confirm("Please confirm product cannot be found");
                        if (confirmationResult === true) {
                            this.state.enteredQty = this.state.scanCountQty;
                            this.confirmQty();
                        }
                        else {
                            return;
                        }
                    }
                    displayConfirmation();
                }
                else {
                    this.setState({ enteredQty: this.state.scanCountQty });
                    this.confirmQty();
                }
            }
            else {
                // NOT PAPERLESS STOCKTAKE, JUST CONFRIM
                this.confirmQty();
            }

        };

        const handleClearBtnClick = e => {

            const displayConfirmation = async () => {
                const confirmationResult = await confirm("Do you really want to clear the scan count label and start again?");
                if (confirmationResult === true) {
                    this.setState({ scanCountQty: 0 });
                }
                else {
                    return;
                }
            }
            displayConfirmation();
          
        };

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";


        return (
            <div>
                <Container>
                    <Row className="mb-3">
                        <Col xs={6}><h5>Adhoc Count - Confirm Quantity</h5></Col>
                        <Col xs={3}><label>{this.state.selectedStockLine.isBlind ? "" : this.state.selectedStockLine.colosysQty}</label></Col>
                        <Col xs={3}><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('AdhocCount_ProductSelect'); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <label> Quantity :</label>
                            <input ref="qtyInput" className="form-control" type="number" value={this.state.enteredQty} disabled={this.state.isScanStocktake === true}
                                onChange={(e) => {
                                    this.setState({ enteredQty: e.target.value });
                                }} onKeyPress={handleQtyInputKeyPress} readOnly={this.state.loading} >
                            </input>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <button type="button" className="btn btn-success col-12 mb-2" onClick={handleConfirmBtnClick}>Next</button>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>
                            <label> Location :</label>
                        </Col>
                        <Col xs={9}>
                            <label> {this.state.locationBarcode.trim()} </label>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>
                            <label> Product :</label>
                        </Col>
                        <Col xs={9}>
                            <label> {this.state.selectedStockLine.productCode.trim()} </label>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>
                            <label> Barcode :</label>
                        </Col>
                        <Col xs={9}>
                            <label> {this.state.productBarCode} </label>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={4}>
                            <label> Description :</label>
                        </Col>
                        <Col xs={12}>
                            <textarea className="form-control" readOnly={true} defaultValue={this.state.selectedStockLine.productDescription.trim()}  ></textarea>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={4}>
                            <label> Desc2 :</label>
                        </Col>
                        <Col xs={12}>
                            <textarea className="form-control" readOnly={true} defaultValue={this.state.selectedStockLine.productDescription2.trim()} ></textarea>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>
                            <label> Status :</label>
                        </Col>
                        <Col xs={9}>
                            <label> {this.state.selectedStockLine.status.trim()} </label>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>
                            <label> Attributes :</label>
                        </Col>
                        <Col xs={9}>
                            <button type="button" className="btn btn-success col-12 mb-2" disabled={!this.state.productHasAttributes} onClick={() => { this.displayAttributes(false); }} >
                                {this.state.productHasAttributes === true ? "Yes - Click to View" : "No"}
                            </button>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>
                            <label> Scan check :</label>
                        </Col>
                        <Col xs={9}>
                            <input ref="scanCheckInput" className="form-control" value={this.state.scanCheckInputValue}
                                onChange={(e) => {
                                    this.setState({ scanCheckInputValue: e.target.value });
                                }} onKeyPress={handleScancheckKeyPress} readOnly={this.state.loading} >
                            </input>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>
                            <input type="checkbox" defaultChecked={this.state.scanCountCheckBoxChecked} disabled={this.state.isScanStocktake}
                                onChange={handleScanCountChkChanged}></input> Scan Count
                        </Col>
                        <Col xs={3}>
                            <label style={{ display: this.state.scanCountCheckBoxChecked === true ? 'block' : 'none' }} > {this.state.scanCountQty} </label>
                        </Col>
                        <Col xs={6}>
                            <button type="button" className="btn btn-success col-12 mb-2" onClick={handleClearBtnClick} >
                                Clear
                            </button>
                        </Col>
                    </Row>
                </Container>
                <ViewAttributes title="Please confirm product attributes are correct" show={this.state.displayViewAttributes} productAttributes={this.state.selectedStockLine} displayAsConfirmationModal={this.state.displayAttributesAsConfirmModal} onClickOk={() => { this.confirmQty() }} onClickClose={() => { this.setState({ displayViewAttributes: false }); }}  ></ViewAttributes>

            </div>)

    }


}
